import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './global.css';
import Sidebar from './components/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';
import LoginPage from './components/Login/LoginPage';

import CreateHostel from './components/HostelDetails/CreateHostel';
import HostelList from './components/HostelDetails/HostelList';
import FoodSupplierList from './components/FoodSupplier/FoodSupplierList';
import NotificationList from './components/Notification/NotificationList';
import CreateNotification from './components/Notification/CreateNotification';
import CreateFoodSupplier from './components/FoodSupplier/CreateFoodSupplier';
import CreateUser from './components/UserMaster/CreateUser';
import UserListPage from './components/UserMaster/UserListPage';
import HostelScheduleVisit from './components/HostelDetails/HostelScheduleVisit';
import HostelRequestCallBack from './components/HostelDetails/HostelRequestCallBack';
import HotelBookingList from './components/HostelDetails/HotelBookingList';
import HostelerRegistrationForm from './components/HostelDetails/HostelerRegistrationForm';
import HostlerList from './components/HostelDetails/HostlerList';
import CreateHostler from './components/HostelDetails/CreateHosteler';
import UserSignUp from './components/UserMaster/UserSignUp';
import CreateHostelMenu from './components/HostelDetails/CreateHostelMenu';
import HostelerTracker from './components/HostelDetails/HostelerTracker';
import Dashboard from './components/Dashboard/Dashboard'; 
import HostellerDashboard from './components/Dashboard/HostellerDashboard';
import HostelOperatorDashboard from './components/Dashboard/HostelOperatorDashboard';
import HotelOperatorDashboard from './components/Dashboard/HotelOperatorDashboard';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import SalesDashboard from './components/Dashboard/SalesDashboard';
import HostlerBill from './components/hostelerPayment/HostlerBill';
import CreateCompany from './components/UserMaster/CreateCompany';
import CompanyListPage from './components/UserMaster/CompanyListPage';
import ChangePassword from './components/UserMaster/ChangePassword';
import ErrorPage from './components/Utils/ErrorPage';
import GlobalErrorBanner from './components/Utils/GlobalErrorBanner';
import StudentHostlerUpdate from './components/HostelDetails/StudentHostlerUpdate';
import ExcelUploadDialog from './components/DataUpload/ExcelUploadDialog';
import HostelReports from './components/Reports/HostelReports';
import AttendanceList from './components/HostelDetails/AttendanceList';
import AuthenticationAudit from './components/UserMaster/AuthenticationAudit';
import HostelerGantt from './components/HostelerGantt/HostelerGantt';
import HostelRunningExpense from './components/hostelerPayment/HostelRunningExpense';
import HostelOwnerEnquiryListPage from './components/UserMaster/HostelOwnerEnquiryListPage';
import Contact from './components/Utils/Contact';
import HostelProfitLoss from './components/hostelerPayment/HostelProfitLoss';
import TemporaryMessStay from './components/GuestManage/TemporaryMessStay';
import SingleBill from './components/GuestManage/SingleBill';
import SalesTracker from './components/AIAgent/SalesTracker';
import AIChatWidget from './components/AIAgent/AIChatWidget';
import SystemSettingConfiguration from './components/Configuration/SystemSettingConfiguration';
import OccupancyPage from './components/occupancy/pages/OccupancyPage';
import CompanyCashFlow from './components/UserMaster/CompanyCashFlow';

const App = () => {
  const location = useLocation();

  const defaultTitle = 'Hostel And PG | Hosteler Web';
  const defaultDescription =
    'Hostel and PG management platform for hostel owners, operators, and hostellers to manage bookings, billing, attendance, and reports.';
  const canonicalUrl = `${window.location.origin}${location.pathname}${location.search}`;

  return (
    <div className="app-container">
      <Helmet>
        <title>{defaultTitle}</title>
        <meta name="description" content={defaultDescription} />
        <meta property="og:title" content={defaultTitle} />
        <meta property="og:description" content={defaultDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={`${window.location.origin}/logo512.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
	  
      <div className="main-content">
        {/* Hide Sidebar on the dashboard page */}
        <GlobalErrorBanner />
        <div className="">
          <Routes>
            <Route path="/error" element={<ErrorPage />} />
			{/* Redirect `/` to `/hostel` */}
          	<Route path="/foodSupplier" element={<Sidebar />} />
			
			{/* Redirect homepage to common property listing page */}
<Route
  path="/"
  element={
    <Navigate
      to={`/property${location.search}`}
      replace
    />
  }
/>

{/* Common listing page for HostelandPG and Guestopsy */}
<Route path="/property" element={<Sidebar />} />

{/* Individual property details */}
<Route
  path="/property/:hostelSlug"
  element={<Sidebar />}
/>

{/* City SEO page */}
<Route
  path="/city/:citySlug"
  element={<Sidebar />}
/>

{/* Legacy Hostel URL redirects */}
<Route
  path="/hostel"
  element={
    <Navigate
      to={`/property${location.search}`}
      replace
    />
  }
/>

<Route
  path="/hostel/:hostelSlug"
  element={
    <Navigate
      to={`/property/${location.pathname.split("/").pop()}${location.search}`}
      replace
    />
  }
/>
			
		      <Route path="/login" element={<LoginPage />} />
            
			 <Route path="/createHostel" element={<CreateHostel />} />
			<Route path="/hostelList" element={<HostelList />} />
			<Route path="/foodSuppliers" element={<FoodSupplierList />} />
			<Route path="/notifications" element={<NotificationList  />} />
			<Route path="/createNotification" element={<CreateNotification  />} />
			<Route path="/createFoodSupplier" element={<CreateFoodSupplier  />} />
			<Route path="/createUser" element={<CreateUser  />} />
			<Route path="/userListPage" element={<UserListPage  />} />
			
			
			<Route path="/hostelScheduleVisit" element={<HostelScheduleVisit />} />
			<Route path="/hostelRequestCallBack" element={<HostelRequestCallBack />} />
			<Route path="/hotelBookingList" element={<HotelBookingList />} />
			<Route path="/hostelerRegistrationForm" element={<HostelerRegistrationForm />} />
			<Route path="/hostlerList" element={<HostlerList />} />
			<Route path="/createHostler" element={<CreateHostler />} />
			<Route path="/userSignUp" element={<UserSignUp />} />
			<Route path="/createHostelMenu" element={<CreateHostelMenu />} />

			<Route path="/createCompany" element={<CreateCompany  />} />
			<Route path="/companyListPage" element={<CompanyListPage  />} />
			<Route path="/changePassword" element={<ChangePassword  />} />
			 <Route path="/hostelerTracker" element={<HostelerTracker />} />
			 
			 <Route path="/hostlerBill" element={<HostlerBill />} />
			 <Route path="/hostellerDashboard" element={<HostellerDashboard />} />
			  <Route path="/hostelOperatorDashboard" element={<HostelOperatorDashboard />} />
			  <Route path="/hotelOperatorDashboard" element={<HotelOperatorDashboard />} />
			  <Route path="/dashboard" element={<Dashboard />} />
			 <Route path="/adminDashboard" element={<AdminDashboard />} />
			 <Route path="/salesDashboard" element={<SalesDashboard />} />
			 
			<Route path="/studentHostlerUpdate" element={<StudentHostlerUpdate />} />
			<Route path="/excelUploadDialog" element={<ExcelUploadDialog />} />
			<Route path="/hostelReports" element={<HostelReports />} />
			<Route path="/attendanceList" element={<AttendanceList />} />
			<Route path="/authenticationAudit" element={<AuthenticationAudit />} />
			<Route path="/hostelerGantt" element={<HostelerGantt />} />
			 <Route path="/hostelRunningExpense" element={<HostelRunningExpense />} />
			 <Route path="/hostelProfitLoss" element={<HostelProfitLoss />} />
			 
			<Route path="/contact" element={<Contact />} />
			<Route path="/enquiryListPage" element={<HostelOwnerEnquiryListPage />} />
			 <Route path="/temporaryMessStay" element={<TemporaryMessStay />} />
			 <Route path="/singleBill" element={<SingleBill />} />
			<Route path="/saleAgent" element={<SalesTracker />} />
			<Route path="/aiChatWidget" element={<AIChatWidget />} />
			<Route path="/occupancyPage" element={<OccupancyPage />} />
			<Route path="/companyCashFlow" element={<CompanyCashFlow />} />
			
			
			<Route path="/systemSettingConfiguration" element={<SystemSettingConfiguration />} />
			
          </Routes>
        </div>
      </div>
      <Footer />
    </div>
  );
};

// Wrap the App component with Router in the main file
const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWrapper;